import { render, staticRenderFns } from "./PortalSearch.vue?vue&type=template&id=3255ca35&lang=pug"
import script from "./PortalSearch.vue?vue&type=script&lang=ts"
export * from "./PortalSearch.vue?vue&type=script&lang=ts"
import style0 from "./PortalSearch.vue?vue&type=style&index=0&id=3255ca35&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports